/*
  Page Japanese Head Spa : comportements legers, sans bibliotheque.
  - apparition des blocs (une seule fois)
  - video du hero coupee si l'utilisatrice limite les animations
  - barre fixe mobile : visible apres le hero, masquee devant l'offre de prevente
  - etat "prevente terminee" selon la date de fin (en complement du rendu serveur)
  - FAQ : une seule question ouverte a la fois
*/
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initReveal() {
    var items = document.querySelectorAll('.hs-reveal');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  function initHeroVideo() {
    if (!reduceMotion) return;
    document.querySelectorAll('.hs-hero video').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  function initMobileBar() {
    var bar = document.querySelector('[data-hs-bar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('[data-hs-hero]');
    var offers = document.querySelectorAll('[data-hs-offers]');
    var heroVisible = true;
    var offersVisible = false;
    var visibleOffers = new Set();

    document.body.classList.add('has-bar');

    function update() {
      var show = !heroVisible && !offersVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    }

    if (hero) {
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        update();
      }).observe(hero);
    } else {
      heroVisible = false;
    }

    if (offers.length) {
      var offersObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visibleOffers.add(entry.target);
          else visibleOffers.delete(entry.target);
        });
        offersVisible = visibleOffers.size > 0;
        update();
      });
      offers.forEach(function (el) { offersObserver.observe(el); });
    }

    update();
  }

  function initPresaleEnd() {
    document.querySelectorAll('[data-hs-end]').forEach(function (section) {
      var end = section.getAttribute('data-hs-end');
      if (!end) return;
      var endTime = new Date(end + 'T23:59:59').getTime();
      if (isNaN(endTime) || Date.now() <= endTime) return;
      var open = section.querySelector('[data-hs-open]');
      var ended = section.querySelector('[data-hs-ended]');
      if (open) open.hidden = true;
      if (ended) ended.hidden = false;
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-hs-faq]').forEach(function (list) {
      var items = list.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  /* Schema annote : chaque etape se place a la hauteur de son point, le trait est horizontal (ordinateur) */
  function initAnatomy() {
    var NS = 'http://www.w3.org/2000/svg';
    var desktop = window.matchMedia('(min-width: 990px)');
    var GAP = 32;
    var SPACING = 28;

    document.querySelectorAll('[data-hs-anatomy]').forEach(function (section) {
      var stage = section.querySelector('.hs-anatomy__stage');
      var svg = section.querySelector('.hs-anatomy__lines');
      var figure = section.querySelector('.hs-anatomy__figure');
      var steps = Array.prototype.slice.call(section.querySelectorAll('[data-hs-step]'));
      if (!stage || !svg || !figure || !steps.length) return;
      var drawn = false;

      function reset() {
        stage.classList.remove('is-placed');
        stage.style.minHeight = '';
        steps.forEach(function (step) { step.removeAttribute('style'); });
        while (svg.firstChild) svg.removeChild(svg.firstChild);
      }

      function place() {
        reset();
        if (!desktop.matches) return;
        stage.classList.add('is-placed');

        var box = stage.getBoundingClientRect();
        var fig = figure.getBoundingClientRect();
        var leftWidth = fig.left - box.left - GAP;
        var rightStart = fig.right - box.left + GAP;
        var rightWidth = box.right - fig.right - GAP;
        svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);

        var placed = { left: [], right: [] };
        steps.forEach(function (step) {
          var n = step.getAttribute('data-hs-step');
          var dot = section.querySelector('[data-hs-dot="' + n + '"]');
          if (!dot) return;
          var side = step.getAttribute('data-side') === 'right' ? 'right' : 'left';
          step.style.width = (side === 'left' ? leftWidth : rightWidth) + 'px';
          step.style.left = (side === 'left' ? 0 : rightStart) + 'px';
          var d = dot.getBoundingClientRect();
          placed[side].push({ step: step, dotX: d.left + d.width / 2 - box.left, dotY: d.top + d.height / 2 - box.top });
        });

        var maxBottom = 0;
        ['left', 'right'].forEach(function (side) {
          var prevBottom = -Infinity;
          placed[side].sort(function (a, b) { return a.dotY - b.dotY; }).forEach(function (item) {
            var name = item.step.querySelector('.hs-anatomy__name') || item.step;
            // 1er passage : estimation ; 2e passage : correction sur la position reelle du titre
            var top = Math.max(0, item.dotY - (name.offsetTop + name.offsetHeight / 2));
            item.step.style.top = top + 'px';
            var nr = name.getBoundingClientRect();
            top += item.dotY - (nr.top + nr.height / 2 - box.top);
            var ideal = top;
            top = Math.max(0, top, prevBottom + SPACING);
            item.step.style.top = top + 'px';
            prevBottom = top + item.step.offsetHeight;
            maxBottom = Math.max(maxBottom, prevBottom);
            // Etape non decalee : trait parfaitement horizontal, a la hauteur du point
            item.lineY = Math.abs(top - ideal) < 1 ? item.dotY : item.dotY + (top - ideal);
          });
        });
        if (maxBottom > box.height) stage.style.minHeight = maxBottom + 'px';
        // Dimensions du dessin fixees apres un eventuel allongement de la scene, sans etirement
        svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + stage.getBoundingClientRect().height);
        svg.setAttribute('preserveAspectRatio', 'xMinYMin meet');

        ['left', 'right'].forEach(function (side) {
          placed[side].forEach(function (item) {
            var isLeft = side === 'left';
            var x0 = isLeft ? leftWidth + 12 : rightStart - 12;
            var edge = isLeft ? fig.left - box.left : fig.right - box.left;
            var outside = document.createElementNS(NS, 'polyline');
            outside.setAttribute('points', x0 + ',' + item.lineY + ' ' + edge + ',' + item.lineY);
            var inside = document.createElementNS(NS, 'polyline');
            inside.setAttribute('points', edge + ',' + item.lineY + ' ' + item.dotX + ',' + item.dotY);
            inside.setAttribute('class', 'is-on-image');
            var start = document.createElementNS(NS, 'circle');
            start.setAttribute('cx', x0);
            start.setAttribute('cy', item.lineY);
            start.setAttribute('r', 2);
            [outside, inside].forEach(function (line) {
              svg.appendChild(line);
              if (!reduceMotion && !drawn) {
                var len = line.getTotalLength ? line.getTotalLength() : 0;
                line.style.strokeDasharray = len;
                line.style.strokeDashoffset = len;
              }
            });
            svg.appendChild(start);
          });
        });
      }

      function reveal() {
        if (drawn) return;
        drawn = true;
        svg.querySelectorAll('polyline').forEach(function (line) { line.style.strokeDashoffset = 0; });
      }

      place();
      if (reduceMotion || !('IntersectionObserver' in window)) {
        reveal();
      } else {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            requestAnimationFrame(reveal);
            io.disconnect();
          }
        }, { threshold: 0.3 });
        io.observe(stage);
      }

      var timer;
      var lastWidth = window.innerWidth;
      function redraw(force) {
        if (!force && window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(timer);
        timer = setTimeout(function () {
          place();
          if (drawn) svg.querySelectorAll('polyline').forEach(function (l) { l.style.strokeDasharray = ''; l.style.strokeDashoffset = ''; });
        }, 120);
      }
      window.addEventListener('resize', function () { redraw(false); });
      section.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { redraw(true); });
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { redraw(true); });
      window.addEventListener('load', function () { redraw(true); });
      if ('ResizeObserver' in window) {
        var sizes = new WeakMap();
        var ro = new ResizeObserver(function (entries) {
          var changed = entries.some(function (e) {
            var h = Math.round(e.contentRect.height);
            var before = sizes.get(e.target);
            sizes.set(e.target, h);
            return before !== undefined && before !== h;
          });
          if (changed) redraw(true);
        });
        section.querySelectorAll('.hs-anatomy__name').forEach(function (el) { ro.observe(el); });
        ro.observe(figure);
      }
    });
  }

  /* Videos secondaires : chargees seulement a l'approche, lues sauf si l'utilisatrice limite les animations */
  function initLazyVideos() {
    var videos = document.querySelectorAll('[data-hs-lazy-video]');
    if (!videos.length) return;
    function load(video) {
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
      });
      video.load();
      if (!reduceMotion) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    if (!('IntersectionObserver' in window)) {
      videos.forEach(load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          load(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px 0px' });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* Decompte jusqu'a la fin de la prevente (minuit, heure de Montreal), actualise chaque minute */
  function initCountdown() {
    var items = document.querySelectorAll('[data-hs-countdown]');
    if (!items.length) return;
    function tick() {
      items.forEach(function (el) {
        var end = montrealMidnight(el.getAttribute('data-hs-countdown'));
        if (isNaN(end)) return;
        var left = end - Date.now();
        if (left <= 0) {
          el.textContent = el.getAttribute('data-ended');
          return;
        }
        var units = (el.getAttribute('data-units') || 'j,h,min').split(',');
        var d = Math.floor(left / 86400000);
        var h = Math.floor((left % 86400000) / 3600000);
        var m = Math.floor((left % 3600000) / 60000);
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        var time = d + ' ' + units[0] + ' ' + pad(h) + ' ' + (units[1] || 'h') + ' ' + pad(m) + ' ' + (units[2] || 'min');
        el.textContent = el.getAttribute('data-label').replace('[temps]', time);
      });
    }
    tick();
    setInterval(tick, 30000);
  }

  /* Minuit a Montreal pour une date AAAA-MM-JJ, heure d'ete ou d'hiver selon la date */
  function montrealMidnight(dateStr) {
    var candidates = ['-04:00', '-05:00'];
    for (var i = 0; i < candidates.length; i++) {
      var d = new Date(dateStr + 'T00:00:00' + candidates[i]);
      if (isNaN(d.getTime())) return NaN;
      try {
        var hour = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', hour: '2-digit', hourCycle: 'h23' }).format(d);
        if (parseInt(hour, 10) === 0) return d.getTime();
      } catch (e) {
        return d.getTime();
      }
    }
    return new Date(dateStr + 'T00:00:00-05:00').getTime();
  }

  /* Grand decompte : jours / heures / minutes jusqu'a minuit (heure de Montreal) le jour de fin */
  function initTimer() {
    var timers = document.querySelectorAll('[data-hs-timer]');
    if (!timers.length) return;
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    function tick() {
      timers.forEach(function (el) {
        var end = montrealMidnight(el.getAttribute('data-hs-timer'));
        if (isNaN(end)) return;
        var left = Math.max(0, end - Date.now());
        var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]');
        if (d) d.textContent = Math.floor(left / 86400000);
        if (h) h.textContent = pad(Math.floor((left % 86400000) / 3600000));
        if (m) m.textContent = pad(Math.floor((left % 3600000) / 60000));
        if (left === 0) {
          var label = el.querySelector('.hs-timer__label');
          if (label) label.textContent = el.getAttribute('data-ended');
        }
      });
    }
    tick();
    setInterval(tick, 20000);
  }

  /* Temoins (cookies) : icone en bas a droite. Le bandeau Shopify reste replie tant qu'on ne clique pas ;
     sans choix, aucun consentement n'est donne. Apres un choix, l'icone rouvre les preferences. */
  function initCookies() {
    var english = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hs-cookie-btn';
    btn.setAttribute('aria-label', english ? 'Cookie preferences' : 'Préférences de témoins (cookies)');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a9 9 0 1 0 9 9 4 4 0 0 1-4-4 4 4 0 0 1-5-5z"/><circle cx="9" cy="10" r="0.8" fill="currentColor"/><circle cx="14" cy="14" r="0.8" fill="currentColor"/><circle cx="9.5" cy="15.5" r="0.8" fill="currentColor"/></svg>';
    document.body.appendChild(btn);

    function close() {
      document.body.classList.remove('hs-cookies-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function () {
      if (document.body.classList.contains('hs-cookies-open')) {
        close();
        return;
      }
      var banner = document.getElementById('shopify-pc__banner');
      var pending = banner && banner.style.display !== 'none';
      if (pending) {
        document.body.classList.add('hs-cookies-open');
        btn.setAttribute('aria-expanded', 'true');
        var first = banner.querySelector('#shopify-pc__banner__btn-accept');
        if (first) first.focus();
      } else if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    });

    // Un choix (accepter, refuser, gerer) referme la petite fenetre
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('#shopify-pc__banner button')) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  /* Liens internes (#prevente, #experience...) : on defile jusqu'a la section, puis on corrige la position
     si la page a bouge entre-temps (images et videos qui se chargent pendant le defilement). */
  function initAnchors() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('a[href^="#"]') : null;
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target || !target.closest('main#root')) return;
      event.preventDefault();
      var behavior = reduceMotion ? 'auto' : 'smooth';
      target.scrollIntoView({ behavior: behavior, block: 'start' });
      [1300, 2200].forEach(function (delay) {
        setTimeout(function () {
          var offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
          if (Math.abs(target.getBoundingClientRect().top - offset) > 24) {
            target.scrollIntoView({ behavior: 'auto', block: 'start' });
          }
        }, delay);
      });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }

  // Typographie : nombre + unite insecables, et jamais un mot seul sur la derniere ligne.
  function initTypo() {
    var root = document.querySelector('main') || document.body;
    var NB = ' ';
    var unit = /(\d)[  ](°C|°|\$|%|min\b|minutes?\b|h\b|heures?\b)/g;
    var blocks = root.querySelectorAll('h1, h2, h3, h4, p, li, dd, dt, figcaption, blockquote, .hs-eyebrow, .hs-formule__hook');
    blocks.forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var nodes = [];
      var n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue.trim() !== '') nodes.push(n);
      }
      nodes.forEach(function (t) {
        if (unit.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(unit, '$1' + NB + '$2');
        unit.lastIndex = 0;
        // Ponctuation double : jamais de « : », « ; », « ? », « ! » en debut de ligne
        if (/ [:;?!»]|« /.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(/ ([:;?!»])/g, NB + '$1').replace(/« /g, '«' + NB);
      });
      // Mot seul : on soude les deux derniers mots du bloc (dernier espace significatif)
      var total = nodes.map(function (t) { return t.nodeValue; }).join('').trim();
      if (total.split(/\s+/).length < 3) return;
      for (var i = nodes.length - 1; i >= 0; i--) {
        var v = nodes[i].nodeValue;
        var end = v.replace(/\s+$/, '');
        var pos = end.lastIndexOf(' ');
        if (pos > 0) {
          nodes[i].nodeValue = end.slice(0, pos) + NB + end.slice(pos + 1) + v.slice(end.length);
          // Si les deux mots soudes ne tiennent pas sur une ligne, le navigateur couperait
          // au milieu (overflow-wrap) : on rend alors l'espace normal.
          var range = document.createRange();
          range.setStart(nodes[i], Math.max(0, end.lastIndexOf(' ', pos - 1) + 1));
          range.setEnd(nodes[i], end.length);
          if (range.getClientRects().length > 1) nodes[i].nodeValue = v;
          break;
        }
      }
    });
  }

  // Fiche produit : le choix de formule met a jour prix, photo, lien du bouton et l'URL (?variant=)
  function initProduct(scope) {
    var root = (scope || document).querySelector('[data-hs-product]');
    if (!root || root.dataset.hsReady) return;
    root.dataset.hsReady = '1';
    var radios = root.querySelectorAll('input[name="hs-formule"]');
    var button = root.querySelector('[data-hs-checkout]');
    var gift = root.querySelector('[data-hs-gift]');
    var now = root.querySelector('[data-hs-now]');
    var was = root.querySelector('[data-hs-was]');
    var saving = root.querySelector('[data-hs-saving]');
    var images = root.querySelectorAll('.hs-product__image');
    var thumbs = root.querySelectorAll('.hs-product__thumb');
    var extras = root.querySelectorAll('input[name="hs-extra"]');
    var totalBox = root.querySelector('[data-hs-total]');
    var totalValue = root.querySelector('[data-hs-total-value]');
    var upsell = root.querySelector('[data-hs-upsell]');
    var upsellGo = upsell ? upsell.querySelectorAll('[data-hs-upsell-go]') : [];
    var upsellMain = upsell ? upsell.querySelector('[data-hs-upsell-main]') : null;
    var upsellRecap = upsell ? upsell.querySelector('[data-hs-upsell-recap]') : null;
    // Carte-cadeau : une variante par combinaison formule + options (SKU -> variante, montant)
    var combos = null;
    var combosEl = root.querySelector('[data-hs-combos]');
    if (combosEl) {
      try { combos = JSON.parse(combosEl.textContent); } catch (e) { combos = null; }
    }

    function money(cents) {
      var amount = cents / 100;
      // En anglais : « $1,210.50 » ; en francais : « 1 210,50 $ »
      if ((document.documentElement.lang || '').toLowerCase().indexOf('en') === 0) {
        var en = amount % 1 === 0 ? String(amount) : amount.toFixed(2);
        return '$' + en.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      var text = amount % 1 === 0 ? String(amount) : amount.toFixed(2).replace('.', ',');
      return text.replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f') + '\u00a0$';
    }

    // Lien de paiement : formule + options cochees (permalien panier), et total affiche
    function updateCheckout() {
      var radio = root.querySelector('input[name="hs-formule"]:checked');
      if (!radio || !button) return;
      var href = radio.dataset.checkout;
      var cents = parseInt(radio.dataset.cents || '0', 10);
      var picked = 0;
      var positions = [];
      // Une option cochee peut en comprendre d'autres (data-includes) : celles-ci se decochent et affichent « Inclus »
      var included = [];
      extras.forEach(function (box) {
        if (box.checked && box.dataset.includes) included = included.concat(box.dataset.includes.split(','));
      });
      extras.forEach(function (box) {
        var row = box.closest('.hs-extra');
        var isIncluded = included.indexOf(box.dataset.position) !== -1;
        if (isIncluded) box.checked = false;
        box.disabled = isIncluded;
        row.classList.toggle('is-included', isIncluded);
        var price = row.querySelector('[data-hs-extra-price]');
        var mention = row.querySelector('[data-hs-extra-included]');
        if (price) price.hidden = isIncluded;
        if (mention) mention.hidden = !isIncluded;
      });
      extras.forEach(function (box) {
        box.closest('.hs-extra').classList.toggle('is-checked', box.checked);
        if (!box.checked) return;
        picked += 1;
        positions.push(parseInt(box.dataset.position, 10));
        href += ',' + box.value + ':1';
        cents += parseInt(box.dataset.cents || '0', 10);
      });
      // Carte-cadeau : les options ne s'ajoutent pas au panier, c'est le montant de la carte qui change
      if (combos && radio.dataset.comboPrefix) {
        positions.sort(function (a, b) { return a - b; });
        var combo = combos[radio.dataset.comboPrefix + (positions.length ? positions.join('.') : '0')];
        href = radio.dataset.checkout;
        cents = parseInt(radio.dataset.cents || '0', 10);
        if (combo) {
          href = radio.dataset.checkout.replace(/[^\/]+$/, combo.id + ':1');
          cents = combo.cents;
        }
      }
      // Avec l'ecran des options, le bouton de la fiche garde le lien de la formule seule (repli sans JS) :
      // ce sont la croix et le bouton de l'ecran qui portent le lien complet.
      button.setAttribute('href', upsell ? radio.dataset.checkout : href);
      upsellGo.forEach(function (link) { link.setAttribute('href', href); });
      if (upsellMain) upsellMain.textContent = picked ? upsellMain.dataset.labelContinue : upsellMain.dataset.labelSkip;
      if (upsellRecap) {
        upsellRecap.textContent = (radio.dataset.name || '') + ' · ' + money(parseInt(radio.dataset.cents || '0', 10));
        upsellRecap.hidden = picked > 0;
      }
      if (totalBox) {
        totalBox.hidden = picked === 0;
        if (totalValue) totalValue.textContent = money(cents);
      }
    }

    function showMedia(id) {
      if (!id) return;
      images.forEach(function (img) { img.classList.toggle('is-active', img.dataset.mediaId === id); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === id); });
    }

    function apply(radio, pushUrl) {
      root.querySelectorAll('.hs-formule').forEach(function (label) {
        label.classList.toggle('is-selected', label.contains(radio));
      });
      updateCheckout();
      // « Offrir le soin » : la carte-cadeau s'ouvre sur le montant de la formule choisie
      if (gift && radio.dataset.gift) gift.setAttribute('href', radio.dataset.gift);
      if (now && radio.dataset.price) now.innerHTML = radio.dataset.price;
      if (was && radio.dataset.was) was.innerHTML = radio.dataset.was;
      if (saving && radio.dataset.saving) saving.innerHTML = radio.dataset.saving;
      showMedia(radio.dataset.mediaId);
      if (pushUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState(null, '', url.toString());
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { apply(radio, true); });
      if (radio.checked) apply(radio, false);
    });
    if (!root.querySelector('.hs-product__image.is-active') && images[0]) showMedia(images[0].dataset.mediaId);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
    });
    extras.forEach(function (box) {
      box.addEventListener('change', updateCheckout);
    });
    updateCheckout();

    // Ecran des options : s'ouvre au clic sur « Reserver ». La croix et le bouton menent au paiement,
    // le fond et la touche Echap ramenent a la fiche.
    if (upsell && button) {
      var upsellPanel = upsell.querySelector('.hs-upsell__panel');
      var onUpsellKey = function (e) {
        if (e.key !== 'Escape') return;
        e.stopPropagation();
        closeUpsell();
      };
      var closeUpsell = function () {
        upsell.classList.remove('is-open');
        upsell.hidden = true;
        document.body.classList.remove('hs-upsell-open');
        document.removeEventListener('keydown', onUpsellKey, true);
        if (root.isConnected) root.appendChild(upsell); else upsell.remove();
        button.focus();
      };
      button.addEventListener('click', function (e) {
        if (!extras.length) return;
        e.preventDefault();
        // Sorti de la fiche le temps de l'affichage : la fiche peut se trouver dans une fenetre qui defile
        document.body.appendChild(upsell);
        upsell.hidden = false;
        requestAnimationFrame(function () { upsell.classList.add('is-open'); });
        document.body.classList.add('hs-upsell-open');
        document.addEventListener('keydown', onUpsellKey, true);
        upsellPanel.focus();
      });
      upsell.querySelector('[data-hs-upsell-back]').addEventListener('click', closeUpsell);
      // Retour depuis le paiement (page restauree par le navigateur) : l'ecran est referme
      window.addEventListener('pageshow', function (e) {
        if (e.persisted && !upsell.hidden) closeUpsell();
      });
    }
  }

  // Fenetre centree qui charge la fiche produit (gabarit "modal") sans quitter la page
  function initModal() {
    var modal = document.querySelector('[data-hs-modal]');
    var triggers = document.querySelectorAll('[data-hs-modal-open]');
    if (!modal || !triggers.length) return;
    var body = modal.querySelector('[data-hs-modal-body]');
    var panel = modal.querySelector('.hs-modal__panel');
    var pageLink = modal.querySelector('[data-hs-modal-page-link]');
    var loaderHtml = body.innerHTML;
    var lastTrigger = null;
    var cache = {};

    function close() {
      modal.hidden = true;
      modal.classList.remove('is-open');
      document.body.classList.remove('hs-modal-open');
      document.removeEventListener('keydown', onKey);
      if (lastTrigger) lastTrigger.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    function render(html) {
      body.innerHTML = html;
      body.querySelectorAll('.hs-reveal').forEach(function (el) { el.classList.add('is-revealed'); });
      body.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      initProduct(body);
      panel.scrollTop = 0;
    }

    function open(trigger) {
      lastTrigger = trigger;
      var url = trigger.getAttribute('data-hs-modal-open');
      if (pageLink && trigger.getAttribute('data-hs-modal-page')) pageLink.setAttribute('href', trigger.getAttribute('data-hs-modal-page'));
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.classList.add('hs-modal-open');
      document.addEventListener('keydown', onKey);
      body.innerHTML = loaderHtml;
      if (cache[url]) { render(cache[url]); panel.focus(); return; }
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('[data-hs-product]');
          if (!section) { window.location.href = trigger.getAttribute('data-hs-modal-page') || url; return; }
          cache[url] = section.outerHTML;
          render(cache[url]);
          panel.focus();
        })
        .catch(function () { window.location.href = trigger.getAttribute('data-hs-modal-page') || url; });
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); open(t); });
    });
    modal.querySelectorAll('[data-hs-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
  }

  onReady(function () {
    initAnchors();
    initCookies();
    initTimer();
    initCountdown();
    initLazyVideos();
    initAnatomy();
    initReveal();
    initHeroVideo();
    initMobileBar();
    initPresaleEnd();
    initFaq();
    initTypo();
    initProduct();
    initModal();
  });
})();
